"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _defaultProps = _interopRequireDefault(require("../defaultProps"));

var _defaultPropTypes = _interopRequireDefault(require("../defaultPropTypes"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.pick"));

var _lodash2 = _interopRequireDefault(require("lodash.xor"));

var _lodash3 = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var pickProperties = ["width", "height", "fillClassName", "transparentClassName", "strokeClassName"];
var excludeProperties = (0, _lodash2.default)(Object.keys(_defaultProps.default), pickProperties);
var DEFAULT_PROPS = (0, _lodash.default)(_defaultProps.default, pickProperties);
var DEFAULT_PROPTYPES = (0, _lodash.default)(_defaultPropTypes.default, pickProperties);

var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, _getPrototypeOf(Table).apply(this, arguments));
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _omit = (0, _lodash3.default)(this.props, excludeProperties),
          fillClassName = _omit.fillClassName,
          transparentClassName = _omit.transparentClassName,
          strokeClassName = _omit.strokeClassName,
          rest = _objectWithoutProperties(_omit, ["fillClassName", "transparentClassName", "strokeClassName"]);

      return _react.default.createElement("svg", _extends({}, rest, {
        viewBox: "0 0 18 18"
      }), _react.default.createElement("rect", {
        className: strokeClassName,
        height: "12",
        width: "12",
        x: "3",
        y: "3"
      }), _react.default.createElement("rect", {
        className: fillClassName,
        height: "2",
        width: "3",
        x: "5",
        y: "5"
      }), _react.default.createElement("rect", {
        className: fillClassName,
        height: "2",
        width: "4",
        x: "9",
        y: "5"
      }), _react.default.createElement("g", {
        className: (0, _classnames.default)(fillClassName, transparentClassName)
      }, _react.default.createElement("rect", {
        height: "2",
        width: "3",
        x: "5",
        y: "8"
      }), _react.default.createElement("rect", {
        height: "2",
        width: "4",
        x: "9",
        y: "8"
      }), _react.default.createElement("rect", {
        height: "2",
        width: "3",
        x: "5",
        y: "11"
      }), _react.default.createElement("rect", {
        height: "2",
        width: "4",
        x: "9",
        y: "11"
      })));
    }
  }]);

  return Table;
}(_react.Component);

exports.default = Table;

_defineProperty(Table, "defaultProps", DEFAULT_PROPS);

_defineProperty(Table, "propTypes", DEFAULT_PROPTYPES);